"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var angular = require("angular");
var toastr = require("toastr");
var moment = require("moment");
var ts_md5_1 = require("ts-md5");
var account_component_1 = require("./account.component");
var youtube_service_1 = require("./youtube.service");
var YouTube = angular
    .module("common.youtube", [])
    .config(function ($stateProvider) {
    "ngInject";
})
    .config(function ($provide) {
    $provide.decorator("youtubeService", function ($delegate) {
        var youtubeWrapper = function (originalFn, cooldownTimeInSeconds) {
            return function () {
                var dateFormat = "DD.MM.YYYY HH:mm:ss";
                var hash = ts_md5_1.Md5.hashStr(originalFn.toString());
                if (cooldownTimeInSeconds) {
                    var data = localStorage.getItem(hash);
                    if (data) {
                        var momentOfAvailability = moment(data, dateFormat)
                            .add(cooldownTimeInSeconds, "second");
                        var currentMoment = moment();
                        if (currentMoment.isBefore(momentOfAvailability)) {
                            var errorMsg = "\u0414\u0430\u043D\u043D\u043E\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E. \u0415\u0433\u043E \u043C\u043E\u0436\u043D\u043E \u0431\u0443\u0434\u0435\u0442 \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u043F\u043E\u0441\u043B\u0435 " + momentOfAvailability.format(dateFormat);
                            toastr.error(errorMsg);
                            throw new Error(errorMsg);
                        }
                    }
                }
                var args = [];
                for (var i = 0; i < arguments.length; i++) {
                    args[i] = arguments[i];
                }
                if ($delegate.isAuthorized) {
                    localStorage.setItem(hash, moment().format(dateFormat));
                    return originalFn.apply($delegate, args);
                }
                else {
                    return $delegate.login().then(function () {
                        localStorage.setItem(hash, moment().format(dateFormat));
                        return originalFn.apply($delegate, args);
                    })
                        .catch(function (data) {
                        if (data.error === "popup_closed_by_user") {
                            toastr.error("Не удалось выполнить действие, т.к. Вы не авторизованы.");
                            console.error(data);
                        }
                    });
                }
            };
        };
        $delegate.checkVideos = youtubeWrapper($delegate.checkVideos, 60);
        $delegate.setRating = youtubeWrapper($delegate.setRating, 60 * 5);
        return $delegate;
    });
})
    .service("youtubeService", youtube_service_1.YouTubeService)
    .component("youtubeAccount", new account_component_1.default);
exports.default = YouTube;



/** WEBPACK FOOTER **
 ** ./src/app/common/youtube/index.ts
 **/